import { InjectionToken } from '@angular/core';
import { Browser } from '@capacitor/browser';
import type { BrowserPlugin } from '@capacitor/browser';

export const CAPACITOR_BROWSER_TOKEN = new InjectionToken<BrowserPlugin>('CapacitorBrowser');

export function provideCapacitorBrowser() {
  return {
    provide: CAPACITOR_BROWSER_TOKEN,
    useValue: Browser,
  };
}
